import React from 'react';
import { observer } from 'mobx-react';
import { Rule } from 'antd/es/form';
import { Catcher, FormSelect } from '../../';
import { ICatalogsUnitItem, ISelectList } from '../../../interfaces';
import { useCurrencyCodeById, useRateInfo, useRateUnitTypeSelect } from '../../../hooks';
import { getUnitLabel } from '../../../middleware';

interface IRateUnitSelect {
    isV2?: boolean;
    name?: string | [number, string];
    rules?: Array<Rule>;
}

export const RateUnitSelect: React.FC<IRateUnitSelect> = observer(
    ({ isV2, name = 'defaultRateDataUnitId', rules = [] }: IRateUnitSelect) => {
        const { currencyId } = useRateInfo();
        const currencyShortCode = useCurrencyCodeById(currencyId);
        const unitList = useRateUnitTypeSelect();

        const useUnitListHook = (): ISelectList =>
            unitList.map((i: ICatalogsUnitItem) => {
                const viewCode = getUnitLabel(i.unit, currencyShortCode);

                return { id: isV2 ? i.unit || i.id : i.id, name: viewCode };
            });

        return (
            <Catcher>
                <FormSelect
                    fieldName={name}
                    isAddonBefore={true}
                    isNotClear={true}
                    isShowSearch={false}
                    rules={rules}
                    useSelectHook={useUnitListHook}
                />
            </Catcher>
        );
    },
);
